import { cartTotalStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCartTotal";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

cartTotalStyles.buttonsGridItem = {
    width: 12,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        // display: none;
                    `,
                ],
                "max",
            )}
        flex-direction: column;
    `,
}

cartTotalStyles.placeOrderButton = {
    mergeCss:true,
    variant: "primary",
    css: css`
        span {
            color: #FFFFFF;
        }
        width:100%;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        width: 100%;
                    `,
                ],
                "min",
            )}
    `,
}

cartTotalStyles.submitForApprovalButton = {
    mergeCss:true,
    variant: "primary",
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        width: 100%;
                    `,
                ],
                "min",
            )}
    `,
}